<template lang="pug">
  .account_info
    LoadingItem(v-if="loading")
    .base_info
      .bat_wrap
        span.department {{ accountInfo.department }}
        span.position(v-if="!isGeneral(accountInfo.position)" :class="'pos_color_' + account.positionId") {{ accountInfo.position }}
      h1
        em(:class="{more_space: accountInfo.name.length < 7}") {{ accountInfo.name }}
        small （{{ accountInfo.nameEn }}）
      .account_btn_wrap(v-if="this.$route.name != 'account'")
        a.tel_btn(v-if="(accountInfo.tel != '' && accountInfo.tel != '-')" :href="'tel:' + accountInfo.tel")
          img(src="@/assets/images/tel.png" alt="電話" width="35" height="35" loading="lazy")

        a.mail_btn(:href="'mailto:' + accountInfo.email")
          img(src="@/assets/images/mail.png" alt="メール" width="35" height="35" loading="lazy")

        a.slack_btn(v-if="slackUrl" :href="slackUrl")
          img(src="@/assets/images/slack.png" alt="Slack" width="35" height="35" loading="lazy")
      .edit_btn_wrap(v-else)
        button.edit.tap_highlight(type="button" @click="openEditForm")
          IconBase(width="21" height="18" icon-name="edit")
            IconEdit
          span プロフィール編集
    .company_info
      dl
        dt
          .label_wrap
            IconBase(width="23" height="20" icon-name="id-card")
              IconIdCard
            span 社員ID
        dd {{ accountInfo.id }}
      dl
        dt
          .label_wrap
            IconBase(width="23" height="20" icon-name="email")
              IconEmail
            span メールアドレス
        dd {{ accountInfo.email }}
      dl(v-if="(accountInfo.tel != '' && accountInfo.tel != '-')")
        dt
          .label_wrap
            IconBase(width="20" height="20" icon-name="phone")
              IconPhone
            span 電話番号
        dd {{ accountInfo.tel }}
      dl
        dt
          .label_wrap
            IconBase(width="18" height="20" icon-name="calendar-alt")
              IconCalendarAlt
            span 入社日
        dd.last
          span.date {{ accountInfo.hireDate }}
    .profile_info
      h2
        span プロフィール
        ShapeHeadBottom
      .profile_inner
        dl
          dt
            .label_wrap
              IconBase(width="18" height="20" icon-name="calendar-check")
                IconCalendarCheck
              span 誕生日
          dd
            span.date {{ accountInfo.birthday }}
            span(v-if="accountInfo.birthday != '-'") （{{ accountInfo.age }}歳）
        dl
          dt
            .label_wrap
              IconBase(width="20" height="17" icon-name="list")
                IconList
              span 得意言語・興味のある言語
          dd.langs
            span(v-if="accountInfo.langs.length == 0") -
            span(v-for="(lang) in accountInfo.langs") {{ lang }}
        dl
          dt
            .label_wrap
              IconBase(width="18" height="20" icon-name="paper-clip")
                IconPaperClip
              span 趣味
          dd.text_data {{ accountInfo.hobby }}
        dl
          dt
            .label_wrap
              IconBase(width="24" height="19" icon-name="comments")
                IconComments
              span フリースペース
          dd.text_data.last(v-html="autoLink(accountInfo.free)")

    ModalItem.profile_edit_modal(
      v-if="isEditOpen"
      title="プロフィール編集"
      submit="更新"
      :isDisabled="cantSubmit"
      @close="cancelEdit"
      @submit="updateProfile"
      :class="{ 'detail_open': isLangsDetailOpen }"
    )
      div.edit_inner
        dl
          dt
            .label_wrap
              IconBase(width="13" height="15" icon-name="calendar-check")
                IconCalendarCheck
              span 誕生日
          dd
            span.date
              Datepicker(
                id="birthday_picker"
                v-model="profileForm.birthday"
                :open-date="accountInfo.birthday == '-' ? new Date('1990/1/1') : new Date(accountInfo.birthday)"
                :language="lang"
                :disabled-dates="disabledDates"
                format="yyyy/M/d"
              )
        dl
          dt
            .label_wrap
              IconBase(width="15" height="15" icon-name="list")
                IconList
              span 得意言語・興味のある言語
          dd.langs(@click="showDetail")
            span(v-if="profileForm.langs.length == 0") -
            span(v-for="(id, idx) in profileForm.langs" :key="idx") {{ id|convertMasterName('langs', master) }}
        .lang_select_wrap(v-if="isLangsDetailOpen")
          .detail_ttl_wrap
            span.back(@click="closeDetail") 戻る
          p.head ※言語を選択してください。
          .detail_contents
            ul.lang_list
              li(v-for="(langs, id) in master.langs" :key="id")
                input(type="checkbox" v-model="profileForm.langs" :value="id" :id="'lang_' + id" )
                label(:for="'lang_' + id") {{ langs.name }}
          .detail_btn_wrap
            button.clear(type="button" @click="clearLang") クリア
            button.decision(type="button" @click="closeDetail") 決定
        dl
          dt
            .label_wrap
              IconBase(width="13" height="15" icon-name="paper-clip")
                IconPaperClip
              span 趣味
          dd
            .flex_text_area
              .dummy_area(aria-hidden="true" v-html="dummyHobby")
              textarea(v-model="profileForm.hobby" @input="inputHobby")
        dl
          dt
            .label_wrap
              IconBase(width="18" height="14" icon-name="comments")
                IconComments
              span フリースペース
          dd.last
            .flex_text_area
              .dummy_area(aria-hidden="true" v-html="dummyFree")
              textarea(v-model="profileForm.free" @input="inputFree")
</template>

<script>
import { mapActions, mapState } from 'vuex'
import account from '@/mixins/account'
import ShapeHeadBottom from './ShapeHeadBottom'
import ModalItem from './ModalItem.vue'
import LoadingItem from './LoadingItem'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
import IconBase from './IconBase.vue'
import IconEdit from './icons/IconEdit.vue'
import IconIdCard from './icons/IconIdCard.vue'
import IconEmail from './icons/IconEmail.vue'
import IconPhone from './icons/IconPhone.vue'
import IconCalendarAlt from './icons/IconCalendarAlt.vue'
import IconCalendarCheck from './icons/IconCalendarCheck.vue'
import IconList from './icons/IconList.vue'
import IconPaperClip from './icons/IconPaperClip.vue'
import IconComments from './icons/IconComments.vue'

export default {
  name: 'AccountInfo',
  data() {
    return {
      loading: false,
      slackUrl: '',
      isEditOpen: false,
      isLangsDetailOpen: false,
      lang: ja,
      disabledDates: {
        to: new Date('1955/1/1'),
        from: new Date(),
      },
      dummyHobby: '',
      dummyFree: '',
      profileForm: {
        birthday: null,
        hobby: '',
        free: '',
        langs: [],
      },
      pristinerProfile: {},
      accountInfo: {},
    }
  },
  props: {
    account: Object,
  },
  components: {
    ShapeHeadBottom,
    ModalItem,
    Datepicker,
    LoadingItem,
    IconBase,
    IconEdit,
    IconIdCard,
    IconEmail,
    IconPhone,
    IconCalendarAlt,
    IconCalendarCheck,
    IconList,
    IconPaperClip,
    IconComments,
  },
  computed: {
    ...mapState('masterModule', ['master']),
    ...mapState('slackModule', ['slackUsers']),
    cantSubmit() {
      if (
        this.pristinerProfile.birthday.toString() !==
          this.profileForm.birthday.toString() ||
        this.pristinerProfile.hobby !== this.profileForm.hobby ||
        this.pristinerProfile.free !== this.profileForm.free ||
        this.pristinerProfile.langs.toString() !==
          this.profileForm.langs.toString()
      ) {
        return false
      } else {
        return true
      }
    },
  },
  mixins: [account],
  created() {
    // アカウントフォーマット化
    this.accountInfo = this.formatAccount(this.account)
    this.profileForm.birthday =
      this.accountInfo.birthday == '-'
        ? ''
        : new Date(this.accountInfo.birthday)
    this.profileForm.hobby =
      this.accountInfo.hobby == '-' ? '' : this.accountInfo.hobby
    this.profileForm.free =
      this.accountInfo.free == '-' ? '' : this.accountInfo.free
    this.profileForm.langs =
      typeof this.account.langs == 'undefined' || !this.account.langs
        ? []
        : this.account.langs
    this.dummyHobby = this.profileForm.hobby + '\u200b'
    this.dummyFree = this.profileForm.free + '\u200b'
  },
  async mounted() {
    let slackUrl = null
    window.scrollTo(0, 0)
    if (this.$route.name !== 'account') {
      if (typeof this.slackUsers !== 'undefined' && this.slackUsers != null) {
        this.slackUsers.some((data) => {
          if (data.profile.email == this.account.email) {
            slackUrl = 'slack://user?team=' + data.team_id + '&id=' + data.id
            return true
          }
        })
      }
    }

    this.slackUrl = slackUrl
    var _ = require('lodash')
    this.pristinerProfile = _.cloneDeep(this.profileForm)
  },
  watch: {
    'profileForm.hobby': function (val) {
      this.profileForm.hobby = val.replace(/\n\n/g, '\n')
      this.dummyHobby = this.profileForm.hobby
    },
    'profileForm.free': function (val) {
      this.profileForm.free = val.replace(/\n\n/g, '\n')
      this.dummyFree = this.profileForm.free + '\u200b'
    },
  },
  methods: {
    ...mapActions('authModule', ['updateAccount']),
    ...mapActions('usersModule', ['setData']),
    inputHobby() {
      this.dummyHobby = this.profileForm.hobby + '\u200b'
    },
    inputFree() {
      this.dummyFree = this.profileForm.free + '\u200b'
    },
    openEditForm() {
      this.isEditOpen = true
    },
    closeEditForm() {
      this.isEditOpen = false
    },
    cancelEdit() {
      this.closeEditForm()
    },
    showDetail() {
      this.isLangsDetailOpen = true
    },
    closeDetail() {
      this.isLangsDetailOpen = false
    },
    clearLang() {
      this.profileForm.langs = []
    },
    autoLink(text) {
      return text
        .replace(/[&'`"<>]/g, function (match) {
          return {
            '&': '&amp;',
            // eslint-disable-next-line quotes
            "'": '&#x27;',
            '`': '&#x60;',
            '"': '&quot;',
            '<': '&lt;',
            '>': '&gt;',
          }[match]
        })
        .replace(/(https?:\/\/[^\s]*)/g, '<a href="$1" target="_blank">$1</a>')
    },
    async updateProfile() {
      this.loading = true
      this.profileForm.langs.map((str) => parseInt(str, 10))
      this.profileForm.langs = Array.from(new Set(this.profileForm.langs))
      this.profileForm.hobby = this.profileForm.hobby
        ? this.profileForm.hobby
        : '-'
      this.profileForm.free = this.profileForm.free
        ? this.profileForm.free
        : '-'
      await this.updateAccount(this.profileForm)
      this.closeEditForm()
      this.$router.go({ name: 'account' })
    },
  },
}
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.account_info {
  position: relative;
  padding: 80px 0 0;
  margin: -5px 0 0;
  background: #fff;
  .base_info {
    margin: 0 auto 35px;
    .bat_wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 0 15px;
      span {
        padding: 7px 10px;
        font-size: 14px;
        margin: 0 5px;
        border-radius: 40px;
        background: #8e9a98;
        color: #fff;
        text-shadow: 1px 1px 1px #afafaf3b;
        font-weight: bold;
        &.position {
          background: #ffcdac;

          &.pos_color_1,
          &.pos_color_2,
          &.pos_color_3,
          &.pos_color_4,
          &.pos_color_5,
          &.pos_color_15,
          &.pos_color_20 {
            background: #ffa3a3;
          }
          &.pos_color_8 {
            background: #88cabe;
          }
          &.pos_color_9,
          &.pos_color_14 {
            background: #87a2cb;
          }
          &.pos_color_27 {
            background: #e0c89e;
          }
          &.pos_color_10,
          &.pos_color_27 {
            background: #e0c89e;
          }
        }
      }
    }
    h1 {
      font-size: 25px;
      em {
        letter-spacing: 1px;
        &.more_space {
          font-size: 28px;
          letter-spacing: 6px;
        }
      }
      small {
        font-size: 15px;
        display: block;
        margin: 5px 0 0;
        letter-spacing: 1px;
      }
    }
    .account_btn_wrap {
      animation: fadeIn 3s ease 0s 1 normal;
      -webkit-animation: fadeIn 3s ease 0s 1 normal;
      position: fixed;
      top: 0;
      right: 5px;
      z-index: 10;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 7px 0;
      a {
        margin: 0 7px;
      }
    }
    .edit_btn_wrap {
      margin: 15px 0 0;
      button {
        padding: 6px 15px;
        font-size: 18px;
        border-radius: 5px;
        cursor: pointer;
        background-color: #88cabe;
        color: #fff;
        background-image: linear-gradient(315deg, #6bc5b3 0%, #88cabe 74%);
        display: flex;
        align-items: center;
        margin: 0 auto;
        line-height: 1.5;
        span {
          padding: 5px 0 4px 5px;
          font-size: 14px;
        }
      }
    }
  }
  dl {
    position: relative;
    padding: 0 20px;
    dt {
      .label_wrap {
        display: flex;
        align-items: center;
        font-size: 20px;
        padding: 10px 5px;
        color: #0da08f;
        svg {
          margin: 0 10px 0 0;
        }
        span {
          font-size: 16px;
          color: #333;
        }
      }
    }
    dd {
      padding: 5px 10px 10px;
      margin: 0 0 15px;
      border-bottom: 1px dashed #d1d1d1;
      text-align: left;
      line-height: 1.7;
      word-wrap: break-word;
      word-break: break-all;
      white-space: pre-line;
      &.langs {
        span::after {
          content: '、';
        }
        span:last-child::after {
          content: none;
        }
      }
      &.last {
        border-bottom: none;
        margin: 0;
      }
      .date {
        letter-spacing: 2px;
      }
    }
  }
  .profile_info {
    text-align: center;
    h2 {
      position: relative;
      font-size: 20px;
      margin: 35px auto 30px;
      padding: 50px 0 65px;
      color: #fff;
      font-weight: bold;
      background-color: #53c6b8;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(182,1084,581)'%3E%3Cstop offset='0' stop-color='%2365ca8f'/%3E%3Cstop offset='1' stop-color='%234dcaba'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='436' height='363.3' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.06'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E");
      background-attachment: fixed;
      background-size: cover;
      &::after {
        content: '';
        background-color: #ffeaac;
        display: block;
        position: absolute;
        left: 0;
        height: 90px;
        width: 90px;
        border-radius: 50%;
        top: 0;
        z-index: -1;
      }
    }
  }
  .company_info,
  .profile_inner {
    @include tab {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      max-width: 1020px;
      margin: 0 auto;
      padding: 0 30px;
      dl {
        width: calc(50% - 20px);
        display: table-row;
        border-bottom: 1px dashed #d1d1d1;
        padding: 0;
        margin: 0 0 20px;
        dt,
        dd {
          max-width: 100%;
          border-bottom: none;
        }
        dd {
          display: flex;
          align-items: flex-start;
          flex-wrap: wrap;
          margin: 0;
          &.text_data {
            display: block;
          }
        }
      }
    }
  }
  .profile_edit_modal {
    .ttl {
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      padding: 5px;
    }
    .edit_inner {
      dl {
        padding: 0;
        dt {
          font-size: 15px;
          span {
            font-size: 15px;
          }
        }
        dd {
          font-size: 13px;
          &.langs {
            position: relative;
            padding: 10px 30px 10px 15px;
            cursor: pointer;
            &::after {
              position: absolute;
              content: '';
              width: 10px;
              height: 10px;
              top: 50%;
              right: 8px;
              border-top: 2px solid #333;
              border-right: 2px solid #333;
              transform: translateY(-50%) rotate(45deg);
            }
          }
          input {
            line-height: 1.5;
            font-size: 13px;
            letter-spacing: 2px;
            padding: 8px 15px;
            display: block;
            width: calc(100% - 30px);
            border-radius: 10px;
            border: 1px solid #d1d1d1;
            background: #fff;
            resize: none;
          }
          .flex_text_area {
            position: relative;
            font-size: 1rem;
            line-height: 1.4;
            font-size: 15px;
            .dummy_area {
              overflow: hidden;
              visibility: hidden;
              box-sizing: border-box;
              padding: 8px 15px;
              min-height: 38px;
              white-space: pre-wrap;
              word-wrap: break-word;
              overflow-wrap: break-word;
              border: 1px solid;
            }
            textarea {
              position: absolute;
              top: 0;
              left: 0;
              box-sizing: border-box;
              padding: 8px 15px;
              width: 100%;
              height: 100%;
              background-color: transparent;
              border: 1px solid #d1d1d1;
              border-radius: 10px;
              color: inherit;
              font: inherit;
              letter-spacing: inherit;
              background: #fff;
              resize: none;
            }
          }
        }
      }
      .lang_select_wrap {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
        z-index: 10;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        .detail_ttl_wrap {
          position: relative;
          display: flex;
          align-items: center;
          font-size: 14px;
          padding: 15px 10px 15px;
          .back {
            cursor: pointer;
            position: relative;
            padding-left: 30px;
            &::before {
              display: block;
              position: absolute;
              top: 50%;
              left: 10px;
              content: '';
              width: 10px;
              height: 10px;
              border-top: 2px solid #333;
              border-right: 2px solid #333;
              transform: translateY(-50%) rotate(-135deg);
            }
          }
        }
        .head {
          font-size: 14px;
          color: #888;
        }
        .detail_contents {
          background: #fff;
          .lang_list {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            padding: 30px 15px 20px;
            li {
              display: inline-block;
              min-width: calc(100% / 3 - 20px);
              margin: 7px 5px;
              input {
                display: none;
              }
              label {
                display: block;
                padding: 8px 10px;
                border-radius: 20px;
                border: 1px solid #d1d1d1;
                font-size: 14px;
                cursor: pointer;
                @include iphone5 {
                  font-size: 12px;
                }
              }
              input:checked + label {
                border: 1px solid #0ab38e;
                box-shadow: 0 0 0 1px #0ab38e inset;
              }
            }
          }
        }
        .detail_btn_wrap {
          position: sticky;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          background: #bbbbbb;
          text-align: right;
          transition: transform 0.4s ease;
          button {
            display: block;
            width: 50%;
            padding: 12px 10px;
            text-align: center;
            cursor: pointer;
            color: #fff;
            margin: 0;
            white-space: nowrap;
            &.clear {
              transition: background-color 0.5s ease;
              font-weight: bold;
              background-color: #eca989;
              background-image: linear-gradient(
                315deg,
                #eca989 0%,
                #ffcca7 74%
              );
            }
            &.decision {
              transition: background-color 0.5s ease;
              font-weight: bold;
              background-color: #88cabe;
              background-image: linear-gradient(
                315deg,
                #6bc5b3 0%,
                #88cabe 74%
              );
            }
          }
        }
      }
    }
    &.detail_open {
      .edit_inner dl {
        height: 94px;
        .dummy_area {
          height: 40px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
#birthday_picker {
  font-size: 14px;
  letter-spacing: 2px;
  padding: 8px 15px;
  display: block;
  min-width: 100%;
  border-radius: 30px;
  border: 1px solid #d1d1d1;
  cursor: pointer;
}
.vdp-datepicker .vdp-datepicker__calendar {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
